import { inject, Injectable } from '@angular/core';
import { type SuperAdmin } from '../../server/services/account.service';
import type { Org, OrgUser } from '../../server/types/org-types';
import { AuthUserService } from './auth-user.service';
import { WebSocketService } from './web-socket.service';

// https://scotch.io/tutorials/protecting-angular-v2-routes-with-canactivatecanactivatechild-guards#toc-authentication-guard
// https://www.youtube.com/watch?v=WveRq-tlb6I
// https://www.youtube.com/watch?v=wswK6AzgvTE

export type UserOrgObj = {
  accountId: string;
  user: OrgUser;
  org: Org;
  superAdmins?: SuperAdmin[];
};

const routeAfterCompleteLogout = '/';

@Injectable()
export class OrgUpdateService {
  private authUserService = inject(AuthUserService);
  private webSocketService = inject(WebSocketService);

  constructor() {
    this.startWebSocket();
  }

  private startWebSocket(): void {
    this.webSocketService.pushObservable.subscribe((socketResult) => {
      if (socketResult.service === 'org' && socketResult.action === 'update') {
        this.authUserService.updateOrg({ org: socketResult.data.org });
      }
    });
  }
}
